import { render, staticRenderFns } from "./ContractPayedTrans.vue?vue&type=template&id=338c60bd&"
import script from "./ContractPayedTrans.vue?vue&type=script&lang=js&"
export * from "./ContractPayedTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports